<template>
  <div class="Block-Drops-Dscr" :class="get_classModify">
    <div class="Block-Drops-Dscr__items">
      <div class="Block-Drops-Dscr__item">
        <div class="Block-Drops-Dscr__icon">
          <AlphaIcon/>
        </div>
        <div class="Block-Drops-Dscr__wrap">
          <p class="Block-Drops-Dscr__ttl">Альфа</p>
          <p class="Block-Drops-Dscr__txt">Анализ монет, обзоры проектов и идеи для заработка</p>
        </div>
      </div>
      <div class="Block-Drops-Dscr__item">
        <div class="Block-Drops-Dscr__icon">
          <PodcastIcon />
        </div>
        <div class="Block-Drops-Dscr__wrap">
          <p class="Block-Drops-Dscr__ttl">Подкасты</p>
          <p class="Block-Drops-Dscr__txt">Три раза в неделю Сергей
            и команда обсуждают рынок, макро и жизнь</p>
        </div>
      </div>
    </div>

    <div class="Block-Drops-Dscr__separator"></div>

    <div class="Block-Drops-Dscr__items">
      <div class="Block-Drops-Dscr__item">
        <div class="Block-Drops-Dscr__icon">
          <CalendarIcon />
        </div>
        <div class="Block-Drops-Dscr__wrap">
          <p class="Block-Drops-Dscr__ttl">Календарь</p>
          <p class="Block-Drops-Dscr__txt">Отслеживаем все важные события крипторынка и мира</p>
        </div>
      </div>
      <div class="Block-Drops-Dscr__item">
        <div class="Block-Drops-Dscr__icon">
          <ForecastersIcon />
        </div>
        <div class="Block-Drops-Dscr__wrap">
          <p class="Block-Drops-Dscr__ttl">Форкастеры</p>
          <p class="Block-Drops-Dscr__txt">Топовые голоса криптотвиттера
            с русским переводом</p>
        </div>
      </div>
    </div>

    <div class="Block-Drops-Dscr__separator"></div>

    <div class="Block-Drops-Dscr__items">
      <div class="Block-Drops-Dscr__item">
        <div class="Block-Drops-Dscr__icon">
          <SignalsIcon />
        </div>
        <div class="Block-Drops-Dscr__wrap">
          <p class="Block-Drops-Dscr__ttl">Сигналы</p>
          <p class="Block-Drops-Dscr__txt">Фиксируем идеи
            и отслеживаем динамику</p>
        </div>
      </div>
      <div class="Block-Drops-Dscr__item">
        <div class="Block-Drops-Dscr__icon">
          <PonchatsIcon />
        </div>
        <div class="Block-Drops-Dscr__wrap">
          <p class="Block-Drops-Dscr__ttl">PoN чаты</p>
          <p class="Block-Drops-Dscr__txt">Закрытые чаты только
            для PoN Holders</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, defineProps} from 'vue';
import {Props} from './scripts/props.js';
//-------------------------------
import AlphaIcon from './icons/svg/AlphaIcon.vue';
import CalendarIcon from './icons/svg/CalendarIcon.vue';
import ForecastersIcon from './icons/svg/ForecastersIcon.vue';
import PodcastIcon from './icons/svg/PodcastIcon.vue';
import PonchatsIcon from './icons/svg/PonchatsIcon.vue';
import SignalsIcon from './icons/svg/SignalsIcon.vue';
//-------------------------------
const props = defineProps(Props());
//-------------------------------
//Применить класс модификатор
const get_classModify = computed(() => props.descriptionAdaptive ? 'Block-Drops-Dscr--adaptive' : '')
</script>

<style scoped lang="scss">
@import './styles/_conf';
</style>
